import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import * as api from 'api';
import * as actionCreators from 'store/actions';

import { Button, Spinner, FormField } from 'components'

const Container = styled.div`
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto auto;
    grid-gap: 0.5rem;
    margin-top: 0.2rem;
`

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    grid-column: 1/ span 2;
`

const BillingEmailInput = props => {
    const { 
        email,
        onClose
    } = props;
    const dispatch = useDispatch()
    const user = useSelector((state) => state.auth.user)
    const [value, setValue] = React.useState(email)
    const [selected, setSelected] = React.useState(false)
    const [showSpinner, setSpinner] = React.useState(false)
    const [error, setError] = React.useState(false)

    const onKeyDownHandler = (event) => {
        if (event.keyCode === 13 ) {
            onSubmit()
        } else if (event.keyCode === 27) {
            onClose && onClose()
        }
    }

    const onSubmit = () => {
        const debug = false
        setSpinner(true)
        setError(null)
        if(value !== email){
            api.updateCustomer({ userId: user['uid'], updates: { email: value }})
            .then(res => {
                debug && console.log('[BillingEmailInput] Email updated')
                dispatch(actionCreators.updateCustomer(res.data['customer']))
                onClose && onClose()
                setSpinner(false)
            })
            .catch(err => {
                debug && console.log('[BillingEmailInput] Email not updated')
                setSpinner(false)
                setError('Changes not made')
            })
        }
    }

    const onChange = v => {
        setValue(v)
        setError(null)
    }

    return (
        <Container>
            {/* Email input */}
            <FormField type='TEXT' label='Email' value={value} selected={selected} error={error}
                onChange={(value) => onChange(value)} onKeyDown={onKeyDownHandler} 
                onFocus={() => setSelected(true)} onBlur={() => setSelected(false)}
                style={{margin: 0, labelWeight: 'normal'}}/>

            {/* Buttons */}
            <ButtonContainer>
                <Button text='Cancel' onSelect={onClose} styles={{backgroundColor:'var(--primary-color)', margin: '0 0.5rem', boxShadowColor: 'transparent'}}/>
                <Button text={showSpinner ? <Spinner styles={{color: 'var(--text-color)'}}/> : 'Save'}
                    onSelect={onSubmit} 
                    styles={{backgroundColor: 'var(--focus-color)', margin: 0, color: 'white'}} />
            </ButtonContainer>
        </Container>
    )
}

export default BillingEmailInput